/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SyncStatus } from './syncStatus';


/**
 * Data payload for \'appointment.synced\' notifications.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface AppointmentSyncedData { 
    appointmentId: number;
    isSyncing: boolean;
    success: boolean;
    syncStatus: SyncStatus;
}
export const AppointmentSyncedData_appointmentId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSyncedData_isSyncing_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSyncedData_success_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSyncedData_syncStatus_Validators: ValidatorFn[] =
    [  Validators.required, ];


